import { t } from '../i18n/t';
import { einheit } from '../rechnung/waehrung';

// Beträge und Fristen wie in der Demo. w: Währung des Belegs (Euro als „€“, sonst das Kürzel, z. B. „1.190,00 USD“).

// „2.950,40 €“
export function eurC(v: number, w = 'EUR'): string {
  return `${betragText(v)} ${einheit(w)}`;
}

// „2.950,40“ ohne Einheit (für Felder)
export function betragText(v: number): string {
  return v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Tage von heute bis zu einem Datum (beides 'YYYY-MM-DD'), negativ = vorbei
export function daysUntil(date: string, today: string): number {
  const day = (s: string) => {
    const [y, m, d] = s.split('-').map(Number) as [number, number, number];
    return Date.UTC(y, m - 1, d) / 86400000;
  };
  return Math.round(day(date) - day(today));
}

// „heute“, „morgen“, „in 5 Tagen“, „seit 2 Tagen überfällig“ (in der Sprache der Mandanten-App, Kanzlei Deutsch)
export function inDays(date: string, today: string): string {
  const n = daysUntil(date, today);
  if (n < 0) return n === -1 ? t('seit 1 Tag überfällig') : t('seit {n} Tagen überfällig', { n: -n });
  return n === 0 ? t('heute') : n === 1 ? t('morgen') : t('in {n} Tagen', { n });
}

// Betrag aus einem Eingabefeld: „2.950,40“, „-120“, „1950.5“ → Zahl; leer → null; ungültig → undefined
export function parseEuro(text: string): number | null | undefined {
  let t = text.replace(/\s|€/g, '').replace(/^−/, '-');
  if (!t) return null;
  // deutsches Format: Punkte trennen Tausender, Komma die Cent
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  else if (/^-?\d{1,3}(\.\d{3})+$/.test(t)) t = t.replace(/\./g, '');
  if (!/^-?\d+(\.\d{1,2})?$/.test(t)) return undefined;
  return Number(t);
}

// „21.400 €“, „−1.250,50 €“ (Cent nur, wenn es welche gibt)
export function eur(v: number, w = 'EUR'): string {
  const a = Math.abs(v);
  const cents = Math.round(a * 100) % 100 !== 0;
  return `${v < 0 ? '−' : ''}${a.toLocaleString('de-DE', { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2 })} ${einheit(w)}`;
}

// mit Vorzeichen: „+3.500 €“, „−1.900 €“
export function eurS(v: number, w = 'EUR'): string {
  return `${v > 0 ? '+' : ''}${eur(v, w)}`;
}

// Betrag der Belegwährung in Euro zum Kurs (Euro je Einheit), auf Cent (Kennzahlen über Belege verschiedener Währung)
export { inEurZahl } from '../rechnung/waehrung';
